import type { PageData } from '../../../../_metronic/helpers/utils/types';
import { getIdealImageSize } from '../../../../_metronic/helpers/utils/utils';

export const aboutData: PageData = [
  {
    formId: 'form1',
    heading: 'About Section',
    data: [
      { id: 'metaName', label: 'Meta title', type: 'input' },
      { id: 'metaContent', label: 'Meta description', type: 'input' },
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'subtitle', label: 'Subtitle', type: 'input' },
      { id: 'content', label: 'Content', type: 'textarea' },
      { id: 'buttonText', label: 'Button text', type: 'input' },
      { id: 'buttonLink', label: 'Button link', type: 'input' },
      {
        id: 'image',
        label: 'Banner Image',
        info: getIdealImageSize(609, 475),
        type: 'image'
      }
    ]
  }
];

export const documentationData: PageData = [
  {
    formId: 'form1',
    heading: 'Documentation Section',
    data: [
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'subtitle', label: 'Subtitle', type: 'input' },
      { id: 'content', label: 'Content', type: 'textarea' }
    ]
  },
  {
    formId: 'formGroup1',
    heading: 'Documentation Plans',
    data: [
      { id: 'image', label: 'Image', info: getIdealImageSize(29, 29), type: 'image' },
      { id: 'content', label: 'Content', type: 'textarea' }
    ]
  },
  {
    formId: 'formGroup2',
    heading: 'Documentation Cards',
    data: [
      { id: 'icon', label: 'Icon', info: getIdealImageSize(48, 48), type: 'image' },
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'subtitle', label: 'Subtitle', type: 'input' },
      { id: 'heading', label: 'Heading', type: 'input' },
      { id: 'content', label: 'Content', type: 'textarea' },
      {
        id: 'partnerImage1',
        label: 'Partner Image 1',
        info: getIdealImageSize(120, 'auto'),
        type: 'image'
      },
      {
        id: 'partnerImage2',
        label: 'Partner Image 2',
        info: getIdealImageSize(120, 'auto'),
        type: 'image'
      },
      { id: 'buttonText', label: 'Button text', type: 'input' },
      { id: 'buttonLink', label: 'Button link', type: 'input' }
    ]
  }
];

export const termsData: PageData = [
  {
    formId: 'form1',
    heading: 'Terms Section',
    data: [
      { id: 'termsTitle', label: 'Terms Title', type: 'input' },
      { id: 'termsButtonText', label: 'Terms Button text', type: 'input' },
      { id: 'termsButtonLink', label: 'Terms Button link', type: 'input' },
      { id: 'eligibilityTitle', label: 'Eligibility Title', type: 'input' },
      { id: 'eligibilityButtonText', label: 'Eligibility Button text', type: 'input' },
      { id: 'eligibilityButtonLink', label: 'Eligibility Button link', type: 'input' },
      {
        id: 'image',
        label: 'Banner Image',
        info: getIdealImageSize(468, 887),
        type: 'image'
      }
    ]
  },
  {
    formId: 'formGroup1',
    heading: 'Terms: Questions and Answers',
    data: [
      { id: 'question', label: 'Terms Question', type: 'textarea' },
      { id: 'answer', label: 'Terms Answer', type: 'textarea' }
    ]
  },
  {
    formId: 'formGroup2',
    heading: 'Eligibility: Questions and Answers',
    data: [
      { id: 'question', label: 'Eligibility Question', type: 'textarea' },
      { id: 'answer', label: 'Eligibility Answer', type: 'textarea' }
    ]
  }
];

export const processData: PageData = [
  {
    formId: 'form1',
    heading: 'Process Section',
    data: [
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'subtitle', label: 'Subtitle', type: 'input' },
      { id: 'note', label: 'Notes', type: 'input' }
    ]
  },
  {
    formId: 'formGroup1',
    heading: 'Loan Process Description',
    data: [
      { id: 'heading', label: 'Content heading', type: 'input' },
      { id: 'content', label: 'Content description', type: 'textarea' }
    ]
  },
  {
    formId: 'formGroup2',
    heading: 'Loan Process Steps',
    data: [
      { id: 'logo', label: 'Step Logo', info: getIdealImageSize(48, 48), type: 'image' },
      { id: 'content', label: 'Step Content', type: 'textarea' }
    ]
  }
];

export const statsData: PageData = [
  {
    formId: 'formGroup1',
    heading: 'Statistics cards',
    data: [
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'subtitle', label: 'Subtitle', type: 'input' },
      { id: 'content', label: 'Content', type: 'textarea' },
      { id: 'image', label: 'Banner Image', info: getIdealImageSize(127, 141), type: 'image' },
      { id: 'link', label: 'Card Link', type: 'input' }
    ]
  }
];
